module.exports = __webpack_public_path__ + "classIcon.png?6afc8effde07739e6e4721d3b112596a";